import { Outlet } from 'react-router-dom'
import { useMemo } from 'react'
// NTTS shell (icon rail + section panel + frosted top bar).
// The original Vuexy layout is still at @layouts/VerticalLayout if needed.
import Layout from './ntts/NttsLayout'

// ** Menu Items
import { hasPermission } from '../utility/Utils'
import userSettings from '../navigation/vertical/userSettings'
import apps from '../navigation/vertical/apps'
import dashboards from '../navigation/vertical/dashboards'

const VerticalLayout = (props) => {
  const menuList = useMemo(() => {
    const filterMenu = (menuArray) => {
      return menuArray
        .filter((item) => !item.show || item.show.some((per) => hasPermission(per)))
        .map((item) => {
          if (item.children) {
            return { ...item, children: filterMenu(item.children) }
          }
          return item
        })
    }

    return filterMenu([...dashboards, ...apps, ...userSettings])
  }, []) // <- add dependencies if permissions can change dynamically

  return (
    <Layout menuData={menuList} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
